import {
    FETCH_AI_AGENTS,
    CLEAN_AI_AGENTS,
    DELETE_AI_AGENT,
    RUN_AI_AGENT,
    PAUSE_AI_AGENT,
} from '../actions/types';
import _ from "lodash";
import {toNumber} from "../functions";

const AI_AGENTS_DEFAULT_STATE = {};

const AiAgentsReducer = (state = AI_AGENTS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_AI_AGENTS:
            return payload;

        case RUN_AI_AGENT:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload)) {
                    item = { ...item, status: 'waiting' };
                }

                return item;
            }) };

        case PAUSE_AI_AGENT:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload)) {
                    item = { ...item, status: 'paused' };
                }

                return item;
            }) };

        case CLEAN_AI_AGENTS:
        case DELETE_AI_AGENT:
            return AI_AGENTS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default AiAgentsReducer;
